interface ExperimentalMessage {
	messageTemplateId: string;
	statsigExperiment: string;
	statsigParameterName: string;
	statsigTestCohort: string;
	statsigAAExperiment?: string;
}

// Entries are iterated through using the ML ranking order - the order in the list is not important
export const EXPERIMENTAL_MESSAGES: ExperimentalMessage[] = [
	{
		messageTemplateId: 'confluence-nudge-for-jira',
		statsigExperiment: 'post-office_expt_confluence-nudge-for-jira',
		statsigAAExperiment: 'post-office_expt_confluence-nudge-for-jira_aa',
		statsigParameterName: 'cohort',
		statsigTestCohort: 'variation',
	},
	{
		messageTemplateId: 'confluence-inline-reactions-mcu-nudge',
		statsigExperiment: 'cc-engagement-convert-dwell-only-mcu-to-react-exp',
		statsigAAExperiment: 'cc-engagement-convert-dwell-only-mcu-exp_aa',
		statsigParameterName: 'cohort',
		statsigTestCohort: 'experiment',
	},
	{
		messageTemplateId: 'confluence-3p-connector-nudge',
		statsigExperiment: 'post-office_3p_user_authentication_nudge',
		statsigParameterName: 'cohort',
		statsigTestCohort: 'variation',
	},
	{
		messageTemplateId: 'rovo-3rd-party-integration-admin-nudge',
		// https://switcheroo.atlassian.com/ui/gates/24208f75-386c-46f9-9c2b-4fa50eaef53c/key/post-office_rovo-admin-nudge_experiment
		statsigExperiment: 'post-office_rovo-admin-nudge_experiment',
		statsigParameterName: 'cohort',
		statsigTestCohort: 'variation',
	},
];
